<template>
    <v-card class="pa-3" flat style="top: 8px;" v-if="monitorListReady">
        <v-layout class="monitor-list-action" row wrap>
            <v-flex md3 v-if="authenticatedUser.is_superadministrator">
                <v-autocomplete
                        :item-text="monitorFilterListItemText"
                        :items="organizationFilter"
                        @change="filterByOrganization"
                        class="mr-3 org-filter"
                        flat
                        height="39"
                        hide-details
                        item-value="uuid"
                        label="Organization"
                        solo
                        v-model="organization"
                >
                    <template slot="selection" slot-scope="{item}">
                        <div class="my-0 text-truncate" style="max-width:180px">{{ item.name }}</div>
                    </template>
                </v-autocomplete>
            </v-flex>
            <v-flex md3>
                <!--:value="monitorListSearch"-->
                <!--@change="value => searchValue = value"-->
                <!-- v-model="monitorListSearch" -->
                <v-text-field
                        @click:clear="searchMonitorList"
                        @keyup.enter="searchMonitorList"
                        :value="monitorListSearch"
                        @change="value => monitorListSearch = value"
                        background-color="#f4f4f4"
                        class="search-box--height"
                        clear-icon="close"
                        clearable
                        flat
                        height="41"
                        hide-details
                        label="Search Here"
                        solo

                />
            </v-flex>
            <v-flex md2>
                <v-btn @click="searchMonitorList" class="mt-0" color="bindezcolor" dark depressed small>
                    <span class="subheading font-weight-regular text-capitalize">Search</span>
                </v-btn>
            </v-flex>
            <v-flex class="text-xs-right ml-auto" md4>
                <v-btn :to="{name: 'monitor-create'}" class="mr-0 mt-0" color="bindezcolor" dark depressed large>
                    <v-icon color="#fff">add</v-icon>
                    <span class="text-capitalize font-weight-regular subheading">Add Monitor</span>
                </v-btn>
            </v-flex>
            <v-flex md12 sm12 xs12>
                <v-data-table
                        :headers="headers"
                        :items="monitorsInfo.monitors"
                        :loading="!monitorPageFetchReady"
                        class="text-capitalize elevation-1"
                        hide-actions
                        item-key="id"
                        v-model="selected">
                    <v-progress-linear color="bindezcolor" indeterminate slot="progress"></v-progress-linear>
                    <template slot="items" slot-scope="props" v-if="monitorListReady">
                        <!--<tr @click="toMentionPage(props.item,$event)">-->
                        <tr @click="toMentionPage(props.item,$event)" @click.right.prevent="toMentionPage(props.item,$event)"
                            style="cursor:pointer;">
                            <td class="text-xs-left body-2 table-text--color">
                                <div :class="{'text-truncate' : $vuetify.breakpoint.lgAndDown}"
                                     class="zawgyi"
                                     style="max-width: 200px;"
                                >
                                    {{ props.item.name | unescapeString }}
                                </div>
                            </td>
                            <td class="text-xs-left">
                                <span style="font-size:0.65rem; display: inline-block; color:var(--bindez-green-color); width: auto; height: auto; padding: 2px;">{{ props.item.type === 'keyword' ? 'BUZZ' : 'PAGE'}}</span>
                            </td>
                            <td class="text-xs-left body-2 table-text--color">
                                <div
                                        class="zawgyi text-truncate"
                                        style="max-width: 200px;"
                                >
                                    {{ props.item.description | unescapeString }}
                                </div>
                            </td>
                            <td class="text-xs-left body-2 table-text--color">
                                <div
                                        class="zawgyi text-truncate"
                                        style="max-width: 200px;"
                                >
                                    {{props.item.user_name}}
                                </div>
                            </td>
                            <td class="text-xs-left body-2 table-text--color">
                                <div
                                    class="zawgyi text-truncate"
                                    style="max-width: 200px;"
                                >
                                    {{props.item.organization_name}}
                                </div>
                            </td>
                            <td :colspan="$vuetify.breakpoint.lgAndDown ? 2 : 1" class="text-xs-left">
                                <v-tooltip slot="append" top>
                                    <v-icon @click.stop="editItem(props.item)" class="mr-2 add-cursor" size="13"
                                            slot="activator">
                                        far fa-edit
                                    </v-icon>
                                    <span>Edit</span>
                                </v-tooltip>

                                <v-tooltip slot="append" top>
<!--                                    <v-icon @click.stop="dialog = true ;monitor = props.item" class="mr-2 add-cursor" size="13"-->
<!--                                            slot="activator">-->
<!--                                        far fa-trash-alt-->
<!--                                    </v-icon>-->
                                    <v-icon @click.stop="deleteWarningDialog = true" class="mr-2 add-cursor" size="13"
                                            slot="activator">
                                        far fa-trash-alt
                                    </v-icon>
                                    <span>Delete</span>
                                </v-tooltip>

                                <v-tooltip slot="append" top>
                                    <v-icon @click.stop="exportMonitor(props.item)" class="add-cursor"
                                            size="13" slot="activator">
                                        fas fa-share-square
                                    </v-icon>
                                    <span>Export</span>
                                </v-tooltip>

                            </td>
                        </tr>
                    </template>
                </v-data-table>
                <v-dialog
                        max-width="600"
                        persistent
                        v-model="dialog"
                >
                    <v-card>
                        <v-card-text>
                            <div class="d-flex fill-height justify-center align-center">
                                <v-icon
                                        :size="60"
                                        class="mr-4"
                                        color="bindezcolor"
                                >
                                    fas fa-exclamation-circle
                                </v-icon>
                                <span class="title font-weight-bold">
                                    Are you sure to delete <span style="color: var(--bindez-green-color)">{{ monitor !== undefined ? monitor.name : 'Monitor' }}</span> monitor? This cannot be undone.
                                </span>
                            </div>
                        </v-card-text>
                        <v-card-actions class="pa-3">
                            <v-btn
                                    @click="dialog = false"
                                    block
                                    color="bindezcolor"
                                    large
                                    outline
                            >Cancel
                            </v-btn>
                            <v-btn
                                    @click="deleteItem"
                                    block
                                    color="bindezcolor"
                                    dark
                                    large
                            >
                                Yes, Delete
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog
                        max-width="600"
                        persistent
                        v-model="deleteWarningDialog"
                >
                    <v-card>
                        <v-card-text>
                            <div class="d-flex fill-height justify-center align-center">
                                <v-icon
                                        :size="60"
                                        class="mr-4"
                                        color="bindezcolor"
                                >
                                    fas fa-exclamation-circle
                                </v-icon>
                                <span class="title font-weight-bold">
                                    This action cannot be completed at this time
                                </span>
                            </div>
                        </v-card-text>
                        <v-card-actions class="pa-3">
                            <v-layout justify-center>
                                <v-flex xs2 align-self-center>
                                    <v-btn
                                            @click="deleteItem"
                                            color="bindezcolor"
                                            dark
                                            large
                                    >
                                        Got it!
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
            <v-flex xs12>
                <div class="text-xs-center">
                    <v-pagination
                            :length="monitorsInfo.total_page"
                            :value="monitorsInfo.current_page"
                            @input="paginate"
                            circle
                            color="bindezcolor"
                            v-if="monitorListReady"
                            v-model="currentPage"
                    ></v-pagination>
                </div>
            </v-flex>
            <v-snackbar
                    color="bindezcolor"
                    top
                    v-model="loadingExport"
            >
                <span class="font-weight-bold">Exporting Monitor!! Please Wait</span>
            </v-snackbar>
        </v-layout>
    </v-card>
    <v-layout align-center column fill-height justify-center v-else>
        <Spinner/>
        <span class="font-weight-bold display-1 description--color ">Loading...</span>
    </v-layout>
</template>

<script>
	import moment from 'moment'
	import {mapActions, mapState, mapMutations} from 'vuex'
	import Spinner from '@/components/Spinner'
	import authCurrentUser from "../mixins/authCurrentUser";
    import _cloneDeep from 'lodash/cloneDeep'
    import _isEmpty from 'lodash/isEmpty'

	export default {
		name: "MonitorList",
		mixins: [authCurrentUser],
		data() {
			return {
				deleteWarningDialog:false,
				monitorListReady: false,
				monitorPageFetchReady: false,
				loadingExport: false,
				currentPage: 1,
				// organization: undefined,
				selected: [],
				dialog: false,
				monitor: undefined,
				headers: [
					{
						text: "Name",
						width: "200",
						value: "name",
						sortable: false,
						class: "subheading | font-weight-regular"
					},
					{
						text: "Type",
						width: "50",
						value: "type",
						sortable: false,
						class: "subheading | font-weight-regular"
					},
					{
						text: "Description",
						width: "300",
						value: "description",
						sortable: false,
						class: "subheading | font-weight-regular"
					},
					{
						text: "Owner",
						width: "200",
						value: "user_name",
						sortable: false,
						class: "subheading | font-weight-regular"
					},
					{
						text: "Organization",
						value: "organization_name",
						sortable: false,
						class: "subheading | font-weight-regular"
					},
					{text: "Options", value: "name", sortable: false, class: "subheading | font-weight-regular"}
				],

				url: process.env.VUE_APP_REDIRECT_URL,
                // monitorListSearch: undefined,
			}
		},
		computed: {
			...mapState([
				'monitorsInfo',
				'organizationFilterList',
			]),

			...mapState({
				targetObj: 'monitor',
			}),

            ...mapState('monitors',[
                "monitorListSearchString",
                "searchMonitorListByOrganization",
            ]),

			organizationFilter() {
				let orgFilters = _cloneDeep(this.organizationFilterList);
				orgFilters.unshift({name: "All", uuid: null});
				return orgFilters;
			},

			monitorListSearch: {
				get() {
					return this.monitorListSearchString;
				},
				set(searchString) {
					this.setMonitorListSearchString(searchString);
				}
			},

			organization: {
				get() {
					return this.searchMonitorListByOrganization;
				},
				set(val) {
					this.setSearchMonitorListByOrganization(val);
				}
			}
		},
		methods: {
			...mapActions([
				'fetchMonitor',
				'fetchUser',
				'fetchMonitors',
				'fetchOrganizationFilterList',
				'fetchSidebarMonitors'
			]),

			...mapActions('monitors', [
				'deleteMonitor'
			]),

			...mapMutations([
				'setMonitor',
                'setMonitorListSearchTerm'
			]),

            ...mapMutations('monitors',[
            	"setMonitorListSearchString",
                "setSearchMonitorListByOrganization",
            ]),

			monitorFilterListItemText(item) {
				return item.name.length >= 25 ? `${item.name.substring(0, 24)}...` : item.name;
			},

			exportMonitor(monitor) {
				this.loadingExport = true
                this.fetchMonitor({monitor_uuid: monitor.monitor_uuid}).then(()=>{
				//this.fetchMonitor(monitor.monitor_uuid).then(() => {
					let data = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(this.targetObj))}`;
					let anchorNode = document.createElement('a');
					anchorNode.setAttribute('href', data);
					anchorNode.setAttribute('download', this.targetObj.name + ".json");
					document.body.appendChild(anchorNode);
					anchorNode.click();
					document.body.removeChild(anchorNode);
					this.loadingExport = false;
				})
			},

			toMentionPage(monitor, $event) {
				if ($event.which === 1) {
					this.$router.push({name: 'mention', params: {monitor_uuid: monitor.monitor_uuid}});

				} else if ($event.which === 3) {
					let routeData = this.$router.resolve({
						name: 'mention',
						params: {monitor_uuid: monitor.monitor_uuid}
					});
					window.open(routeData.href, "_blank");
				}
				this.$store.commit('setSelectedDates', [
					moment().subtract(3, 'month').utc().format('YYYY-MM-DD'),
					moment().format('YYYY-MM-DD')
				]);
			},

			editItem(item) {
				this.$router.push({name: 'edit-monitor', params: {monitor_uuid: item.monitor_uuid}})
			},

			deleteItem() {
				this.deleteWarningDialog = false;
				this.$ua.trackEvent("Delete Monitor", "click", `${this.authenticatedUser.email || 'User'} delete monitor(${this.monitor.monitor_uuid})`);
				// this.deleteMonitor(this.monitor.monitor_uuid).then(() => {
				// 	this.dialog = false
				// 	this.monitorListReady = false
				// 	this.fetchMonitors({page: this.currentPage}).then(() => this.monitorListReady = true)
				// })
			},

			paginate() {
				this.monitorPageFetchReady = false;
				this.$ua.trackEvent("Paginate Monitors List", "click");
				this.fetchMonitors({
					page: this.currentPage,
					organization_uuid: this.organization,
					search: this.monitorListSearch
				}).then(() => this.monitorPageFetchReady = true)
			},

			filterByOrganization() {
				this.currentPage = 1;
				this.monitorListSearch = undefined;
				this.monitorPageFetchReady = false;
				this.fetchMonitors({organization_uuid: this.organization}).then(() => this.monitorPageFetchReady = true)
			},

			searchMonitorList(event) {
				this.$ua.trackEvent("Search Monitor", "click");
				this.organization = undefined;
				//if (!this.monitorListSearch || this.monitorListSearch.length <= 1) return;
				this.currentPage = 1;
				this.monitorPageFetchReady = false;
				if (event.target.innerText === 'close' || !this.monitorListSearch) this.monitorListSearch = undefined;
				this.fetchMonitors(
					{search: this.monitorListSearch}
				).then(() => this.monitorPageFetchReady = true)
			},

		},

		created() {
			if (this.authenticatedUser.is_superadministrator) this.fetchOrganizationFilterList();
			this.fetchSidebarMonitors();
			// this.setMonitor({});
            this.setMonitor({data:{}});
			if (_isEmpty(this.monitorsInfo)) {
				this.monitorListReady = false;
				this.monitorPageFetchReady = false;
				this.fetchMonitors({page: this.currentPage}).then(() => {
					this.monitorListReady = true;
					this.monitorPageFetchReady = true;
				})
			} else {
				this.monitorListReady = true;
				this.monitorPageFetchReady = true;
				this.currentPage = this.monitorsInfo.current_page;
			}
		},

		components: {
			Spinner
		}
	}
</script>

<style>
    .add-cursor {
        cursor: pointer;
    }

    .v-btn.v-btn--small, .v-btn.v-btn--large {
        height: 41px;
    }

    .org-filter {
        border: 1px solid var(--bindez-green-color);
    }

    .v-text-field.v-text-field--solo .v-input__control {
        min-height: 25px;
    }

    .search-box--height.v-text-field.v-text-field--solo .v-input__control {
        min-height: 25px;
    }

    .table-text--color {
        color: rgba(0, 0, 0, 0.6);
    }
</style>
